import { breakpoints } from '@notino/react-styleguide';

import { styled } from '@linaria/react';

export const fifteenPx = '0.9375rem';
export const colPct = (cols: number): string => `${(100 / 12) * cols}%`;

export const Container = styled.section`
  @media (min-width: ${breakpoints.md}) {
    float: left;
    margin: 1.5625rem 0 4rem;
    width: 100%;
    box-sizing: border-box;
    display: flex;
    padding: 0 0.9375rem;
  }
`;

export const MarginWrapper = styled.div`
  height: inherit;
  width: 100%;
`;

export const RoutineWrapper = styled.div`
  display: block;
  overflow-y: hidden;
  height: inherit;
  margin: 1.5rem 0;

  @media (min-width: ${breakpoints.sm}) {
    margin: calc(${fifteenPx} * 2) 0 0;
  }

  @media (min-width: ${breakpoints.md}) {
    display: block;
  }
`;

export const Placeholder = styled.div`
  width: 100%;
  height: 1rem;
`;
